import styled from 'styled-components'
import { DefaultTheme } from 'styled-components'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.styles'
import { ColorSchemeTypes } from '../../../types/ColorScheme'

interface CardFeaturesProps {
  theme: DefaultTheme,
  colorScheme: ColorSchemeTypes,
  withBackground?: boolean
}

interface CardFeaturesImageProps {
  theme: DefaultTheme
}

export const CardFeatures = styled.div<CardFeaturesProps>`
  width: 100%;

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-right: ${theme.rem(38)};
  `)};    

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`

export const CardFeaturesImage = styled.div<CardFeaturesImageProps>`
  width: 100%;
  position: relative;
  aspect-ratio: 4 / 3;
  border-radius: ${({ theme }) => theme.rem(8)};
  overflow: hidden;
  
  img {
    object-fit: cover;
    object-position: center;
  }
`
